import { serviceMaker, methods, api } from "@/http/index.js";

export const getMediaList = () =>
    serviceMaker(`/assets/mediadata`, methods.GET, api.NGB);
export const getMediaElementTemplate = () =>
    serviceMaker(`/assets/template`, methods.GET, api.NGB);
export const createMediaElement = (data) =>
    serviceMaker(`/assets`, methods.POST, api.NGB, data);
export const editMediaElementData = (id) =>
    serviceMaker(`/assets/${id}?template=true`, methods.GET, api.NGB);
export const dataByIdMedia = (id) =>
    serviceMaker(`/assets/${id}`, methods.GET, api.NGB);
export const updateMediaElement = (payload) =>
    serviceMaker(`/assets/${payload.id}`, methods.PUT, api.NGB, payload.data);
export const getAddAttributesTemplate = () =>
    serviceMaker(`/assets/template`, methods.GET, api.NGB);
export const createAddAttribute = (id, data) =>
    serviceMaker(`/assets/locationAttributes/${id}`, methods.POST, api.NGB, data);
export const createEvent = (data) =>
    serviceMaker(`/eventmaster`, methods.POST, api.NGB, data);
export const addEventPrice = (id, data) =>
    serviceMaker(`/eventprice/${id}`, methods.POST, api.NGB, data);
export const updateEventPrice = (id, data) =>
    serviceMaker(`/eventprice/${id}`, methods.PUT, api.NGB, data);
export const getEventTemplate = () =>
    serviceMaker(`/eventmaster/template`, methods.GET, api.NGB);
export const getEventList = () =>
    serviceMaker(`/eventmaster`, methods.GET, api.NGB);
export const viewEventDataById = (id) =>
    serviceMaker(`/eventmaster/${id}`, methods.GET, api.NGB);
export const eventPriceTemplate = (id) =>
    serviceMaker(`/eventprice/template?eventId=${id}`, methods.GET, api.NGB);
export const deleteEventPrice = (id) =>
    serviceMaker(`/eventprice/${id}`, methods.DELETE, api.NGB);
export const deleteEvent = (id) =>
    serviceMaker(`/eventmaster/${id}`, methods.DELETE, api.NGB);
export const updateEvent = (id, data) =>
    serviceMaker(`/eventmaster/${id}`, methods.PUT, api.NGB, data);
